import { Calendar } from './Calendar'
import { Sidebar } from './Sidebar'

export const components = {
  Sidebar,
  Calendar,
}
